import { render, staticRenderFns } from "./ncmap.vue?vue&type=template&id=94b04940&scoped=true&"
import script from "./ncmap.vue?vue&type=script&lang=js&"
export * from "./ncmap.vue?vue&type=script&lang=js&"
import style0 from "./ncmap.vue?vue&type=style&index=0&id=94b04940&lang=stylus&scoped=true&"
import style1 from "./ncmap.vue?vue&type=style&index=1&id=94b04940&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b04940",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94b04940')) {
      api.createRecord('94b04940', component.options)
    } else {
      api.reload('94b04940', component.options)
    }
    module.hot.accept("./ncmap.vue?vue&type=template&id=94b04940&scoped=true&", function () {
      api.rerender('94b04940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/granary/map/newMap/ncmap.vue"
export default component.exports